export default class ItineraryManager {
    constructor() {
        this.itinerariesModal = document.querySelector('#itineraryModal');
        const multipleItinerariesContainer = document.querySelector('[data-itineraries]');
        this.multipleItineraries = multipleItinerariesContainer ? multipleItinerariesContainer.getAttribute('data-itineraries') > 1 : false;
        this.eventDelegation();
    }

    eventDelegation() {
        const body = $('body');

        body.on('click', '#itineraryModal [data-element="modal-close"]', () => {
            if (this.multipleItineraries) {
                this.resetItineraryModal();
            }

            const stickyBottomResume = document.querySelector('[data-entity="sticky-bottom-resume"]');
            if (stickyBottomResume) {
                stickyBottomResume.classList.remove('sticky-container-active');
            }
        });

        body.on('click', '[data-action="showItineraryModal"]', () => {

            if (!this.itinerariesModal) return;

            if (this.multipleItineraries) {
                this.resetItineraryModal();
            }

            const infoCholloModal = document.querySelector('#info_chollo_modal');
            if (infoCholloModal) {
                infoCholloModal.addEventListener('custom-modal-hidden', () => {
                    myApp.customModalManager.openModal('#itineraryModal');
                }, {once: true});
                myApp.customModalManager.closeModal('#info_chollo_modal');
            } else {
                this.openModal(this.itinerariesModal);
                if (this.multipleItineraries) {
                    return;
                }

                const stickyBottomResume = document.querySelector('[data-entity="sticky-bottom-resume"]');
                if (stickyBottomResume && stickyBottomResume.clientHeight > 0) {
                    stickyBottomResume.classList.add('sticky-container-active');
                    this.itinerariesModal.querySelector('.itinerary-container').classList.add('pb-9');
                }
            }
        });

        body.on('click', '[data-action="showItineraryInfoModal"]', () => {

            if (!this.itinerariesModal) return;

            if (this.multipleItineraries) {
                this.resetItineraryModal();
            }

            this.openModal(this.itinerariesModal);
            if (this.multipleItineraries) {
                return;
            }

            const stickyBottomResume = document.querySelector('[data-entity="sticky-bottom-resume"]');
            if (stickyBottomResume && stickyBottomResume.clientHeight > 0) {
                stickyBottomResume.classList.add('sticky-container-active');
                this.itinerariesModal.querySelector('.itinerary-container').classList.add('pb-9');
            }

        });

        if (myApp.deviceDetector.isXsScreen() || myApp.deviceDetector.isSmScreen()) {
            body.on('click', 'input[type="radio"][name="itineraries"]', (event) => {
                event.preventDefault();
                event.stopPropagation();

                const currentTarget = event.currentTarget;
                this.selectItinerary(currentTarget);

                if (!this.itinerariesModal) return;
                this.itinerariesModal.classList.add('show-timeline', 'custom-modal-back');

                const itineraryLabel = currentTarget.parentElement.querySelector('[for="' + currentTarget.id + '"]');
                if (!itineraryLabel) return;

                const modalTitle = itineraryLabel.querySelector('[data-entity="itinerary-name"]');
                if (!modalTitle) return;

                this.itinerariesModal.querySelector('[data-entity="custom-modal-title"]').innerHTML = modalTitle.innerHTML;
            });

            body.on('click', '#itineraryModal [data-element="modal-back"]', (event) => {
                this.resetItineraryModal();
            });
        }

        body.on('change', 'input[type="radio"][name="itineraries"]', (event) => {
            this.selectItinerary(event.currentTarget);
            const itinerariesTimelineScroll = document.querySelector('[data-entity="itineraries-timeline-scroll"]');
            if (itinerariesTimelineScroll) {
                itinerariesTimelineScroll.scrollTop = 0;
            }
        });

        body.on('click', '[data-show-itinerary-modal]', (event) => {
            const currentTarget = event.currentTarget;

            const modalId = currentTarget.getAttribute('data-show-itinerary-modal');
            if (!modalId) return;

            const shareData = {
                title: currentTarget.getAttribute('data-share-title'),
                text: currentTarget.getAttribute('data-share-description')
            }

            const isMobile = myApp.deviceDetector.isXsScreen() || myApp.deviceDetector.isSmScreen();
            const canShare = navigator.canShare && navigator.canShare(shareData);
            if (canShare && isMobile) {
                navigator.share(shareData).then(r => {});
            } else {
                myApp.customModalManager.openModal(modalId);
            }
        });

        let urlParams = new URLSearchParams(document.location.search);
        if (urlParams.has('itinerary')) {
            this.openModal(this.itinerariesModal);
            const itineraryId = urlParams.get('itinerary');
            if (itineraryId) {
                const itineraryButton = document.querySelector('#itinerary-' + itineraryId);
                if (itineraryButton) itineraryButton.click();
            }
        }
    }

    resetItineraryModal() {
        this.itinerariesModal.classList.remove('show-timeline', 'custom-modal-back');
        this.itinerariesModal.querySelector('[data-entity="custom-modal-title"]').innerHTML = myApp.translator['group.itinerary.modal_title'];
    }

    selectItinerary(itinerary) {
        const itinerarySelected = itinerary.getAttribute('id');
        if (!itinerarySelected) return;

        const itinerariesInfo = document.querySelectorAll('[data-entity="itinerary-timeline"]');

        if (itinerariesInfo.length > 0) {
            itinerariesInfo.forEach((itinerary) => {
                if (itinerary.getAttribute('data-itinerary') === itinerarySelected) {
                    itinerary.classList.add('active');
                } else {
                    itinerary.classList.remove('active');
                }
            });
        }
    }

    openModal(itineraryModal) {
        if (!itineraryModal) return;
        const itineraryChecked = itineraryModal.querySelector('input[type="radio"][name="itineraries"]:checked');
        if (itineraryChecked) {
            itineraryModal.querySelector('[data-itinerary=' + itineraryChecked.getAttribute('id') + ']').classList.add('active');
        }
        myApp.customModalManager.openModal('#itineraryModal');
    }
}
